var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPayrollIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6,
    cx: 22.5,
    cy: 22.5,
    r: 22.5,
    fill: "#E1EBF6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3359_3132)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3359_3132)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_3359_3132)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.9992 25C20.3447 25 18.9992 23.6545 18.9992 22C18.9992 20.3455 20.3447 19 21.9992 19C23.6537 19 24.9992 20.3455 24.9992 22C24.9992 23.6545 23.6537 25 21.9992 25ZM21.9992 20.5C21.172 20.5 20.4992 21.1727 20.4992 22C20.4992 22.8273 21.172 23.5 21.9992 23.5C22.8265 23.5 23.4992 22.8273 23.4992 22C23.4992 21.1727 22.8265 20.5 21.9992 20.5ZM16.7492 18.25C16.3353 18.25 15.9992 18.586 15.9992 19C15.9992 19.414 16.3353 19.75 16.7492 19.75C17.1632 19.75 17.4992 19.414 17.4992 19C17.4992 18.586 17.1632 18.25 16.7492 18.25ZM26.4993 20.5C26.4993 20.914 26.8353 21.25 27.2493 21.25C27.6632 21.25 27.9993 20.914 27.9993 20.5C27.9993 20.086 27.6632 19.75 27.2493 19.75C26.8353 19.75 26.4993 20.086 26.4993 20.5ZM16.7492 22.75C16.3353 22.75 15.9992 23.086 15.9992 23.5C15.9992 23.914 16.3353 24.25 16.7492 24.25C17.1632 24.25 17.4992 23.914 17.4992 23.5C17.4992 23.086 17.1632 22.75 16.7492 22.75ZM26.4993 25C26.4993 25.414 26.8353 25.75 27.2493 25.75C27.6632 25.75 27.9993 25.414 27.9993 25C27.9993 24.586 27.6632 24.25 27.2493 24.25C26.8353 24.25 26.4993 24.586 26.4993 25ZM25.7485 28.75C24.523 28.75 23.425 28.4508 22.3637 28.1613C21.3527 27.8853 20.3987 27.625 19.3742 27.625C18.196 27.625 17.4527 27.7008 16.81 27.8868C15.9055 28.147 14.9545 27.9715 14.2 27.4037C13.4372 26.83 13 25.954 13 25V19.339C13 17.7917 13.9743 16.381 15.4248 15.8282C16.4305 15.4442 17.3815 15.25 18.2508 15.25C19.4762 15.25 20.5735 15.5493 21.6355 15.8388C22.6465 16.1148 23.6005 16.375 24.625 16.375C25.8025 16.375 26.5465 16.2993 27.1893 16.1133C28.0953 15.853 29.0462 16.0285 29.8 16.5963C30.5627 17.17 31 18.046 31 19V24.661C31 26.2083 30.025 27.619 28.5745 28.1718C27.5688 28.5557 26.6185 28.75 25.7485 28.75ZM19.3742 26.125C20.5997 26.125 21.697 26.4242 22.759 26.7137C23.77 26.9897 24.724 27.25 25.7485 27.25C26.434 27.25 27.205 27.0888 28.0405 26.77C28.9278 26.4325 29.5 25.6045 29.5 24.661V19C29.5 18.5222 29.2803 18.0828 28.8978 17.7955C28.5235 17.5143 28.0533 17.4258 27.604 17.5547C26.8158 17.782 25.9525 17.875 24.6235 17.875C23.398 17.875 22.3007 17.5758 21.2387 17.2863C20.2277 17.0103 19.2738 16.75 18.2492 16.75C17.563 16.75 16.7928 16.9112 15.9573 17.23C15.07 17.5675 14.4978 18.3955 14.4978 19.339V25C14.4978 25.4777 14.7175 25.9173 15.1 26.2045C15.4743 26.4858 15.9445 26.5743 16.393 26.4445C17.1813 26.2173 18.0452 26.1243 19.3735 26.1243L19.3742 26.125Z",
    fill: "#323232"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3359_3132"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(13 13)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3359_3132"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(13 13)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_3359_3132"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(13 13)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayrollIcon);
export default __webpack_public_path__ + "static/media/PayrollIcon.4168aa7718f79edc3c9c755a1c9d3ed3.svg";
export { ForwardRef as ReactComponent };